import {
  SETTING_CHANGE_INFO,
  SETTING_CHANGE_TABLE_OPTIONS,
  SETTING_CHANGE_VALUE,
  SETTING_CHANGE_VALUES,
  SETTING_CLOSE_ACTION_MODAL,
  SETTING_PLATFORM_USERS,
  SETTING_TECHNICIAN_USERS,
  SETTING_USER,
  SETTING_TECHNICIAN,
  SETTING_DISABLE_USER,
  SETTING_DISABLE_TECHNICIAN,
  SETTING_ERROR,
  ADMIN_LOGOUT,
} from '@shared/store/constants/mutationTypes';
import initialState from '@shared/store/setting/settingInitialState';

const mutations = {
  [SETTING_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;
    state[field] = value;
  },
  [SETTING_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [SETTING_CHANGE_TABLE_OPTIONS]: (state, payload) => {
    const {
      options,
      field,
      value,
    } = payload;
    state[options][field] = value;
  },
  [SETTING_CHANGE_INFO]: (state, payload) => {
    const {
      obj,
      field,
      value,
    } = payload;

    const newObj = {
      ...state[obj],
      [[field]]: value,
    };

    state[obj] = newObj;
  },
  [SETTING_PLATFORM_USERS]: (state, payload) => {
    const {
      platformUsers,
    } = payload;

    state.platformUsers = platformUsers;
    state.loadingPlatformUsers = false;
  },
  [SETTING_TECHNICIAN_USERS]: (state, payload) => {
    const {
      technicianUsers,
    } = payload;

    state.technicianUsers = technicianUsers;
    state.loadingTechnicians = false;
  },
  [SETTING_USER]: (state, payload) => {
    const {
      result,
    } = payload;

    const {
      actionModalView,
      platformUsers,
    } = state;

    if (actionModalView === 'new-user') {
      state.platformUsers = [...platformUsers, result];
    } else {
      state.platformUsers = state.platformUsers.map((pu) => {
        if (pu.id === result.id) {
          return result;
        }
        return pu;
      });
    }
    state.editing = false;
  },
  [SETTING_TECHNICIAN]: (state, payload) => {
    const {
      result,
    } = payload;

    const {
      technicianUsers,
      actionModalView,
    } = state;

    if (actionModalView === 'new-technician') {
      state.technicianUsers = [...technicianUsers, result];
    } else {
      state.technicianUsers = state.technicianUsers.map((tu) => {
        if (tu.id === result.id) {
          return result;
        }
        return tu;
      });
    }
    state.editing = false;
  },
  [SETTING_DISABLE_USER]: (state, payload) => {
    const {
      id,
    } = payload;

    state.platformUsers = state.platformUsers.filter((u) => u.id !== id);
    state.editing = false;
  },
  [SETTING_DISABLE_TECHNICIAN]: (state, payload) => {
    const {
      id,
    } = payload;

    state.technicianUsers = state.technicianUsers.filter((u) => u.id !== id);
    state.editing = false;
  },
  [SETTING_ERROR]: (state, payload) => {
    const {
      errorObj,
    } = payload;
    state.errorObj = errorObj;
  },
  [SETTING_CLOSE_ACTION_MODAL]: (state) => {
    state.showActionModal = false;
    state.actionModalView = '';
    state.errorObj = {};
    state.currentUser = {
      superAdmin: false,
      corporationId: 0,
    };
    state.currentTechnician = {
      corporationId: 0,
    };
  },
  [ADMIN_LOGOUT](state) {
    Object.assign(state, initialState());
  },
};

export default mutations;
